import React from 'react';
import { NavLink } from 'react-router-dom';
import Layout from './Layout';
import { useTheme } from '../context/ThemeContext';
import Member from '../nav logo/membersimage-removebg-preview.png';
import MemeberimageconThree from '../nav logo/usersimage-removebg-preview.png';
import Visitors from '../nav logo/visitor-removebg-preview.png';

  function Members() {
  const { isDark } = useTheme();
  return (
    <Layout title="Members Directory">
        <div className="flex-1 overflow-y-auto p-4">
          <div className="bg-gradient-to-r from-green-800 to-yellow-300 rounded-t-xl p-6">
            <h1 className="text-white text-3xl font-bold">Members Directory</h1>
            <p className="text-white text-xs font-semibold mb-6 mt-3">
              Manage and view all church members in one place. Search, filter and perform actions on
              member records.
            </p>
          </div>

          {/* Summary Boxes */}
            <div className="bg-white dark:bg-gray-800 rounded-b-xl shadow p-4 -mt-4 flex flex-wrap justify-between">
            <div className="bg-green-900 text-white p-4 rounded-xl w-[47%] mb-4 md:w-48">
              <div className="flex items-center gap-3">
                <div className="bg-green-700 p-2 rounded-full">
                  <img src={Member} alt="member" className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xl font-bold">547</p>
                  <p className="text-xs">Total Members</p>
                </div>
              </div>
            </div>

            <div className="bg-green-500 text-white p-4 rounded-xl w-[47%] mb-4 md:w-48">
              <div className="flex items-center gap-3">
                <div className="bg-green-700 p-2 rounded-full">
                  <img src={Member} alt="active" className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xl font-bold">201</p>
                  <p className="text-xs">Active</p>
                </div>
              </div>
            </div>

            <div className="bg-blue-500 text-white p-4 rounded-xl w-[47%] mb-4 md:w-48">
              <div className="flex items-center gap-3">
                <div className="bg-blue-700 p-2 rounded-full">
                  <img src={MemeberimageconThree} alt="new" className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xl font-bold">547</p>
                  <p className="text-xs">New (30d)</p>
                </div>
              </div>
            </div>

              <div className="w-full flex justify-center gap-3 md:ml-20">
              <NavLink to="/newmember">
                <div className="flex items-center gap-2 bg-indigo-700 hover:bg-indigo-600 text-white p-2 text-xs rounded-md">
                  <img src={MemeberimageconThree} className="w-5 h-5" alt="Add" />
                  <span>Add New Member</span>
                </div>
              </NavLink>
              <NavLink to="/newmember">
                <div className="flex items-center gap-2 bg-indigo-700 hover:bg-indigo-600 text-white p-2 text-xs rounded-md">
                  <img src={Visitors} className="w-5 h-5" alt="Group" />
                  <span>Group Management</span>
                </div>
              </NavLink>
            </div>
          </div>

          {/* Filters */}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow mt-6">
            <label
              htmlFor="searchandfilter"
              className="block text-gray-700 dark:text-white font-bold"
            >
              Search & Filters
            </label>
            <div className="mt-4 flex flex-wrap gap-4">
              <input
                type="search"
                id="searchandfilter"
                placeholder="Search members"
                className="p-2 w-full md:w-1/2 border text-gray-700 font-semibold border-gray-300 rounded-md"
              />
              <select className="p-2 border text-gray-700 font-semibold border-gray-300 rounded-md">
                <option>All Departments</option>
                <option>Ministers</option>
                <option>Choir</option>
                <option value="">Technical</option>
                <option value="">Hospitality</option>
                <option value="">Deacons</option>
                <option value="">Elders</option>
                <option value="">Ushering</option>
                <option value="">Security and Protocol</option>
                <option value="">Children</option>
                <option value="">Sanitary</option>
              </select>
              <select className="p-2 border text-gray-700 font-semibold border-gray-300 rounded-md">
                <option>All Status</option>
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>
          </div>

          {/* Member List */}

          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow mt-6">
            <h1 className="text-green-900 dark:text-yellow-200 font-bold text-sm">Members List</h1>

            {/* Make table horizontally scrollable on small screens */}
            <div className="mt-4 overflow-x-auto">
              <table className="w-full text-gray-700 font-bold text-sm text-left border-collapse min-w-[600px]">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 border-b">Name</th>
                    <th className="p-2 border-b">Department</th>
                    <th className="p-2 border-b">Status</th>
                    <th className="p-2 border-b">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Example Rows */}
                  <tr className="hover:bg-gray-100 bg-white  hover:duration-700">
                    <td className="p-2 border-b">John Doe</td>
                    <td className="p-2 border-b">Choir</td>
                    <td className="p-2 border-b">Active</td>
                    <td className="p-2 border-b">
                      <NavLink to="/newmember" className="text-blue-500 hover:underline">
                        View
                      </NavLink>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-100 bg-white  hover:duration-700">
                    <td className="p-2 border-b">Jane Smith</td>
                    <td className="p-2 border-b">Hospitality</td>
                    <td className="p-2 border-b">Inactive</td>
                    <td className="p-2 border-b">
                      <NavLink to="/newmember" className="text-blue-500 hover:underline">
                        View
                      </NavLink>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-100 bg-white  hover:duration-700">
                    <td className="p-2 border-b">Alice Johnson</td>
                    <td className="p-2 border-b">Technical</td>
                    <td className="p-2 border-b">Active</td>
                    <td className="p-2 border-b">
                      <NavLink to="/newmember" className="text-blue-500 hover:underline">
                        View
                      </NavLink>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-100 bg-white  hover:duration-700">
                    <td className="p-2 border-b">Bob Brown</td>
                    <td className="p-2 border-b">Deacons</td>
                    <td className="p-2 border-b">Active</td>
                    <td className="p-2 border-b">
                      <NavLink to="/newmember" className="text-blue-500 hover:underline">
                        View
                      </NavLink>
                    </td>
                  </tr>
                  {/* Add more rows as needed */}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-200">
                    <td colSpan="4" className="p-2 text-center">
                      Total Members: 547
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
    </Layout>
  );
}

export default Members;
